import type { InvitationToken, PublicEventContentObject } from 'models';
import { useState } from 'react';
import { useUser } from 'features/auth';
import { SharedEventEnterFormCard, type SharedEventEnterFormValues } from '../../../../components';
import { useEnterEvent } from '../../../../queries';

type P = {
  eventContentObject: PublicEventContentObject;
  invitationToken: InvitationToken;
};

const SharedProgramEventForm = ({ eventContentObject, invitationToken }: P) => {
  const user = useUser({ requiredAuth: false });
  const [isRedirecting, setIsRedirecting] = useState(false);
  const { isPending: isEnteringEvent, mutate: enterEvent } = useEnterEvent();

  const onFinish = (values: SharedEventEnterFormValues) => {
    enterEvent(
      { eventId: eventContentObject.event.id, invitationToken: invitationToken.token, ...values },
      {
        onSuccess() {
          setIsRedirecting(true);
        },
      },
    );
  };

  return (
    <SharedEventEnterFormCard
      initialValues={{
        email: user?.railsUserData.email,
        firstName: user?.railsUserData.firstName,
        lastName: user?.railsUserData.lastName,
      }}
      loading={isEnteringEvent || isRedirecting}
      onFinish={onFinish}
    />
  );
};

export default SharedProgramEventForm;
